import ArrowIcon from "@icons/ArrowIcon";
import type { PaginationProps } from "antd";
import { Pagination } from "antd";
import { useTranslation } from "react-i18next";

const PAGINATION_STYLES = {
  item: [
    "[&_.ant-pagination-item]:flex",
    "[&_.ant-pagination-item]:size-10",
    "[&_.ant-pagination-item]:items-center",
    "[&_.ant-pagination-item]:justify-center",
    "[&_.ant-pagination-item]:rounded-xl",
    "[&_.ant-pagination-item]:border-0",
    "[&_.ant-pagination-item]:bg-mainColor",
    "[&_.ant-pagination-item]:font-bold",
    "[&_.ant-pagination-item]:ring-1",
    "[&_.ant-pagination-item]:ring-secondTextColor/15",
  ].join(" "),
  itemActive: [
    "[&_.ant-pagination-item-active]:!bg-activeColor/20",
    "[&_.ant-pagination-item-active]:!ring-0",
    "[&_.ant-pagination-item-active_a]:!text-activeColor",
  ].join(" "),
  itemHover: "[&_.ant-pagination-item:hover]:bg-secondTextColor/25",
  prev: [
    "[&_.ant-pagination-prev]:flex",
    "[&_.ant-pagination-prev]:size-10",
    "[&_.ant-pagination-prev]:items-center",
    "[&_.ant-pagination-prev]:justify-center",
    "[&_.ant-pagination-prev]:rounded-xl",
    "[&_.ant-pagination-prev]:border-0",
    "[&_.ant-pagination-prev]:bg-mainColor",
    "[&_.ant-pagination-prev]:ring-1",
    "[&_.ant-pagination-prev]:ring-secondTextColor/15",
  ].join(" "),
  prevDisabled: "[&_.ant-pagination-prev.ant-pagination-disabled]:bg-secondTextColor/15 [&_.ant-pagination-prev.ant-pagination-disabled_button]:cursor-not-allowed",
  next: [
    "[&_.ant-pagination-next]:flex",
    "[&_.ant-pagination-next]:size-10",
    "[&_.ant-pagination-next]:items-center",
    "[&_.ant-pagination-next]:justify-center",
    "[&_.ant-pagination-next]:rounded-xl",
    "[&_.ant-pagination-next]:border-0",
    "[&_.ant-pagination-next]:bg-mainColor",
    "[&_.ant-pagination-next]:ring-1",
    "[&_.ant-pagination-next]:ring-secondTextColor/15",
  ].join(" "),
  nextDisabled: "[&_.ant-pagination-next.ant-pagination-disabled]:bg-secondTextColor/15 [&_.ant-pagination-next.ant-pagination-disabled_button]:cursor-not-allowed",
  link: [
    "[&_.ant-pagination-item-link]:flex",
    "[&_.ant-pagination-item-link]:items-center",
    "[&_.ant-pagination-item-link]:justify-center",
  ].join(" "),
  prevArrow: "[&_.ant-pagination-prev]:rtl:-scale-x-100",
  nextArrow: "[&_.ant-pagination-next]:ltr:-scale-x-100",
};

const PAGINATION_CLASS = Object.values(PAGINATION_STYLES).join(" ");

interface StyledPaginationProps extends PaginationProps {
  current: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
}

const StyledPagination = ({
  current,
  total,
  pageSize,
  onChange,
  ...rest
}: StyledPaginationProps) => {
  const { i18n } = useTranslation();

  return (
    <Pagination
      className={PAGINATION_CLASS}
      current={current}
      itemRender={(_, type, originalElement) => {
        if (type === "prev") {
          return (
            <button className="flex size-10 items-center justify-center">
              <ArrowIcon className="text-activeColor" height={14} width={14} />
            </button>
          );
        }
        if (type === "next") {
          return (
            <button className="flex size-10 items-center justify-center">
              <ArrowIcon className="text-activeColor" height={14} width={14} />
            </button>
          );
        }
        return originalElement;
      }}
      locale={{
        prev_page: i18n.language === "ar" ? "الصفحة السابقة" : "Previous Page",
        next_page: i18n.language === "ar" ? "الصفحة التالية" : "Next Page",
      }}
      onChange={onChange}
      pageSize={pageSize}
      showSizeChanger={false}
      total={total}
      {...rest}
    />
  );
};

export default StyledPagination;
